<template>
  <div class="banners-view">
    <div class="left-banners">
      <div class="title" v-html="getWordings.aboutBannerTitle"></div>
      <div class="description" v-html="getWordings.aboutBannerDescription"></div>
    </div>
    <div class="right-banners">
      <img v-if="true" :src="aboutAnimation + '?ts=' + timestamp" />
      <div class="image-background"></div>
    </div>
    <div class="about-triangle-mobile">
      <img :src="require('@/assets/images/triangle-home-mob.svg')" />
    </div>
  </div>
</template>

<script lang="ts">
// @ is an alias to /src
import { Vue, Component, Prop } from "vue-property-decorator";
import aboutAnimation from "@/assets/animation/about.svg";
import { Getter } from "vuex-class";
@Component({
  name: "AboutBannersView",
  components: {}
})
export default class AboutBannersView extends Vue {
  @Getter("text/getWordings") getWordings!: any;
  @Prop({ type: String }) private timestamp!: string;
  aboutAnimation: string = aboutAnimation;
}
</script>

<style lang="scss" scoped>
.banners-view {
  @include layoutPadding();
  @include flex(left, center);
  flex-wrap: nowrap;
  position: relative;
  background-color: $gs8;
  padding-right: 0;
  @include mq(l) {
    padding-top: 40px;
    @include flex(center, center);
  }
  .about-triangle-mobile {
    display: none;
    img {
      width: 100vw;
    }
    @include mq(l) {
      display: block;
      position: absolute;
      bottom: 0;
    }
  }
  .left-banners {
    text-align: left;
    max-width: 600px;
  }

  .right-banners {
    position: relative;
    width: 100%;
    > img {
      position: absolute;
      z-index: 1;
      top: 95px;
      left: 150px;
      @include mq(l) {
        display: inline-block;
        width: 100%;
        position: relative;
        top: 4px;
        left: unset;
        margin-top: 76.3px;
      }
    }
  }

  .image {
    @include size(500px, 500px);
    background-color: $gs6;
    @include mq(l) {
      margin-top: 40px;
    }
    @include mq(m) {
      @include size(315px);
    }
  }

  .image-background {
    @include size(100%, 500px);
    background-color: $orbit-color;
    position: relative;
    margin-left: 340.5px;
    @include mq(l) {
      display: none;
    }
  }
  .image-background:before {
    content: "";
    @include size(353.54px);
    border-bottom-left-radius: 15px;
    background-color: $orbit-color;
    transform: rotate(45deg);
    position: absolute;
    left: -178px;
    top: 73px;
  }

  .title {
    @include titleFz(xl);
    @include fw(heavy);
    line-height: 60px;
    margin-bottom: 20px;
    @include mq(m) {
      @include titleFz(xs);
      text-align: center;
    }
  }

  .description {
    @include titleFz(xs);
    line-height: 40px;
    @include mq(m) {
      @include fz(m);
      text-align: center;
    }
    // @include fw(heavy);
  }
}
</style>
